<script setup>
import {Link, useForm} from "@inertiajs/inertia-vue3";
import Layout from "../Layouts/Authenticated.vue";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { onBeforeMount, onMounted, ref } from "vue";
import axios from "axios";
import { debounce } from "../utils/debounce"
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import {useToast} from "primevue/usetoast";

const props = defineProps([
    'canManageCustomers',
]);
const programLabelMap = ref({
    'muscle_building': 'Muskelaufbau',
    'local_fat_deposits': 'Lokale Fettpolster',
    'overweight': 'Übergewicht',
    'longevity': 'Longevity',
    'cellulite': 'Cellulite',
    'incontinence': 'Inkontinenz',
    'stress': 'Stress',
    'tiredness': 'Müdigkeit',
    'fitness_training': 'Fitness-Training',
})
const toast = useToast();
const dt = ref(null)
const customers = ref([])
const totalRecords = ref(0)
const loading = ref(false)
const search = ref('')
const first = ref(0)
const isVisibleDeleteDialog = ref(false)
const customerDelete = ref(null)
const deleting = ref(false)

const debounceSearch = debounce(async () => {
    loading.value = true

    const { data } = await axios.get('/ajax/customers', {
        params: {
            s: search.value
        }
    })

    customers.value = data.customers.data
    totalRecords.value = data.customers.total
    first.value = 0

    loading.value = false
}, 300)

const onPage = async (e) => {
    loading.value = true

    const { data } = await axios.get('/ajax/customers', {
        params: {
            page: e.page + 1
        }
    })

    customers.value = data.customers.data

    loading.value = false
}

const showDeleteCustomerDialog = (e, customer) => {
    customerDelete.value = customer
    isVisibleDeleteDialog.value = true
}

const deleteCustomer = (e) => {
    deleting.value = true

    useForm({}).delete(`/customers/${customerDelete.value.uuid}`, {
        preserveState: false,

        onSuccess: (page) => {
            const fullName = (customerDelete.value.first_name + ' ' + customerDelete.value.last_name).trim()

            toast.add({
                severity: "success",
                summary: `${fullName} wurde gelöscht`,
                life: 5000,
            });
        },

        onFinish: (visit) => {
            isVisibleDeleteDialog.value = false
            deleting.value = false
        }
    });
}

onBeforeMount( async () => {
    loading.value = true

    const { data } = await axios.get('/ajax/customers')

    customers.value = data.customers.data
    totalRecords.value = data.customers.total

    loading.value = false
})
</script>
<template>
    <Layout>
        <div class="lato max-w-7xl mx-auto p-4 my-10">
            <div class="px-2 text-xl font-semibold mb-7">Kunden</div>
            <div class="my-4">
                <InputText v-model="search"
                           v-model:first="first"
                           type="text"
                           class="w-full"
                           placeholder="Suche"
                           @input="debounceSearch" />
            </div>
            <div class="">
                <DataTable :value="customers"
                           :totalRecords="totalRecords"
                           :loading="loading"
                           :rows="10"
                           dataKey="id"
                           ref="dt"
                           @page="onPage($event)"
                           lazy
                           paginator>
                    <Column header="Nachname" field="last_name"></Column>

                    <Column header="Name" field="first_name"></Column>

                    <Column header="Email" field="email">
                        <template #body="props">

                            <Link :href="(canManageCustomers) ? `/customers/${props.data.uuid}/trainingsplan` : `/customer-sessions/${props.data.uuid}/start` ">{{ props.data.email }}</Link>
                        </template>
                    </Column>

                    <Column header="Program">
                        <template #body="props">
                            {{
                                (props.data.plan?.program)
                                    ? programLabelMap[props.data.plan?.program]
                                    : (
                                        (props.data.answer?.programs?.length)
                                            ? programLabelMap[props.data.answer.programs[0]]
                                            : ''
                                    )

                            }}
                        </template>
                    </Column>

                    <Column header="">
                        <template v-if="canManageCustomers"
                                  #body="props">
                            <i class="pi pi-trash cursor-pointer"
                               @click="showDeleteCustomerDialog($event, props.data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>

        <Dialog v-model:visible="isVisibleDeleteDialog"
                header="Konfirmation"
                :style="{ width: '40rem' }"
                modal>
            <div class="mb-7">
                <div v-if="customerDelete"
                     class="flex items-center gap-4">
                    <i class="pi pi-exclamation-triangle text-2xl"></i>

                    Sind Sie sicher, dass Sie {{ customerDelete.first_name }} {{ customerDelete.last_name }} löschen wollen?
                </div>
            </div>


            <div class="flex justify-end gap-2">
                <Button
                    type="button"
                    label="Abbrechen"
                    severity="secondary"
                    class="text-sm"
                    @click="isVisibleDeleteDialog = false" />

                <Button
                    :loading="deleting"
                    type="button"
                    label="Löschen"
                    class="text-sm"
                    @click="deleteCustomer"></Button>
            </div>
        </Dialog>
    </Layout>
</template>
